import moment from 'moment'
//金额保持小数点后两位
export function keepTwo (val) {
  var f = parseFloat(val);
  if (isNaN(f)) {
      return '0.00';
  }
  var f = Math.round(val*100)/100;
  var s = f.toString();
  var rs = s.indexOf('.');
  if (rs < 0) {
      rs = s.length;
      s += '.';
  }
  while (s.length <= rs + 2) {
      s += '0';
  }
  return s;
}

  export function getPercent(a, b) {
    a = parseFloat(a);
    b = parseFloat(b);
    if (isNaN(a) || isNaN(b) ) {
        return "-";

    }
    if(a < b){
      return  '-'+(Math.round( ( b - a ) / b * 10000) / 100.00)+"%";
    }else if( b == 0){
      return (Math.round( a * 10000) / 100.00)+"%";
    }
    else{
      return (Math.round((a - b )/ b * 10000) / 100.00)+"%";
    }
   //     GetPercent(1,100)；
    // 结果：1%；percentage

}
export function pertage(a, b) {
   if(a == null || a == undefined){
      return 0;
   }else if(b == null || b == undefined){
     return 100;
   }else{
    return (Math.round( a / b * 10000) / 100.00);
   }
}
export function showMainBodyLabel(val, arr){
  let temp = ''
  for (let i=0;i<arr.length;i++) {
      if (val==arr[i].id) {
      temp = arr[i].name
      }
  }
  return temp
}
// 处理规格
export function specsFilter (val) {
  if(val) {
    let list = JSON.parse(val)
    let newList = []
    list.forEach(item => {
      newList.push(item.specName + ' : ' + item.specValue)
    })
    let str = newList.join(',  ')
    return str
  }else {
    return val
  }
}
// 结算方式
export function paymentTypeFilter (val) {
  switch (val) {
    case 10:
      return '无账期';
    case 20:
      return '全款预付';
    case 30:
      return '货到付款';
    case 190:
      return '预付10%到货付清尾款';
    case 200:
      return '预付10%票到7天内付清尾款';
    case 210:
      return '预付10%票到15天内付清尾款';
    case 220:
      return '预付10%票到30天内付清尾款';
    case 40:
      return '预付30%到货付清尾款';
    case 50:
      return '预付30%票到7天内付清尾款';
    case 60:
      return '预付30%票到15天内付清尾款';
    case 70:
      return '预付30%票到30天内付清尾款';
    case 80:
      return '预付50%票到7天内付清尾款';
    case 90:
      return '预付50%票到15天内付清尾款';
    case 100:
      return '预付50%票到30天内付清尾款';
    case 110:
      return '票到付款';
    case 120:
      return '票到7天付款';
    case 130:
      return '票到15天付款';
    case 140:
      return '月结15天';
    case 150:
      return '月结15天';
    case 160:
      return '月结15天';
    case 170:
      return '月结90天';
  }
}
// 销售订单状态
export function saleStatusFilter (val) {
  switch (val) {
    case 1:
      return 'edp内部审核中';
    case 10:
      return '审批中';
    case 11:
      return '审批完成';
    case 12:
      return '待付款';
    case 13:
      return '账期待审核';
    case 14:
      return '待上传合同';
    case 20:
      return '待发货-预处理';
    case 30:
      return '待发货-等补货';
    case 40:
      return '待发货-已就绪';
    case 50:
      return '待出库';
    case 51:
      return '部分发货';
    case 60:
      return '已发货';
    case 61:
      return '待结清';
    case 70:
      return '已完成';
    case 80:
      return '已关闭';
    case 90:
      return '已撤回';
    case 100:
      return '已驳回';
  }
}
// 付款方式
export function payFilter (val) {
  switch (val) {
    case 10:
      return '线下支付';
    case 20:
      return '账期支付';
    case 30:
      return '对公账户-预付';
    case 31:
      return '对公账户-票到付款';
    case 32:
      return '对公账户-货到付款';
    case 40:
      return '线上支付';
    case 50:
      return '货到票到';
  }
}
//代码如下所示：
export function toBig(money) {
  //汉字的数字
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
  //基本单位
  var cnIntRadice = new Array('', '拾', '佰', '仟');
  //对应整数部分扩展单位
  var cnIntUnits = new Array('', '万', '亿', '兆');
  //对应小数部分单位
  var cnDecUnits = new Array('角', '分', '毫', '厘');
  //整数金额时后面跟的字符
  var cnInteger = '整';
  //整型完以后的单位
  var cnIntLast = '元';
  //最大处理的数字
  var maxNum = 999999999999999.9999;
  //金额整数部分
  var integerNum;
  //金额小数部分
  var decimalNum;
  //输出的中文金额字符串
  var chineseStr = '';
  //分离金额后用的数组，预定义
  var parts;
  if (money == '') { return ''; }
  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return '';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  //转换为字符串
  money = money.toString();
  if (money.indexOf('.') == -1) {
    integerNum = money;
    decimalNum = '';
  } else {
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != '') {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '') {
    chineseStr += cnInteger;
  }
  return chineseStr;
}
export function dateFmt(input, formatString = "YYYY-MM-DD HH:mm:ss"){
  //es5函数参数设置默认值
  //const lastFormatString = formatString ||
   // moment(input) 把时间字符串转成时间对象
   // format(formatString) 把时间对象，按照指定格式，格式化成符合条件的字符串
   if(input) {
     return moment(input).format(formatString)
   }else {
     return input
   }
}
export function fmtDate(val, num) {
  let str = val;
  if (val) {
      str = val.substring(0, 10);
  }
  return str;
}









// WEBPACK FOOTER //
// ./src/filters/index.js